import { useRef, useEffect } from 'react'
/**
 * MagneticCursor — a small dot that tracks the cursor and expands
 * into a lime circle over anything interactive (links, buttons, inputs).
 * Skipped entirely on touch devices.
 */
export function MagneticCursor() {
  const ref = useRef()
  useEffect(() => {
    if (window.matchMedia('(pointer: coarse)').matches) return
    const el    = ref.current
    const move  = e => { el.style.left = `${e.clientX}px`; el.style.top = `${e.clientY}px` }
    const over  = e => { if (e.target.closest('a,button,[role="button"],input,textarea')) el.classList.add('hover') }
    const out   = e => { if (e.target.closest('a,button,[role="button"],input,textarea')) el.classList.remove('hover') }
    window.addEventListener('mousemove', move)
    document.addEventListener('mouseover', over)
    document.addEventListener('mouseout',  out)
    return () => {
      window.removeEventListener('mousemove', move)
      document.removeEventListener('mouseover', over)
      document.removeEventListener('mouseout',  out)
    }
  }, [])
  return <div id="mcur" ref={ref} />
}
